import { ddpClickType } from '../../constants';

const createDdpLink = (isKbb, href, isPayingDealer, clickType) => {
    if (clickType === ddpClickType.VIEW_CAR_CLICK) {
        href = href?.split('?')[0] || '';
    }
    const joinChar = href?.includes('?') ? '&' : '?';
    let tabParam = '';
    if (isPayingDealer && clickType === ddpClickType.SCHEDULE_CLICK) {
        tabParam = 'dealerdetailstabs=service#service';
    } else if (isPayingDealer && isKbb && clickType === ddpClickType.DEALER_CARD_CLICK) {
        tabParam = 'dealerdetailstabs=reviews#reviews';
    }
    return href + (tabParam && `${joinChar}${tabParam}`);
};

export default createDdpLink;
